/**
 * NGX display Auth Twitter object.
 *
 * Summary of responsibilities:
 *
 *  - handles all functionality related to authenticating users against Twitter
 */
export default (function() {
  // Properties.
  var _config = {
      id:    'Twitter',
      ngxId: 'twitter',

      // Twitter does not provide a way to handle auth on the client,
      // so in these cases, auth must be proxied through to the server side.
      ngxAuthProxyURI: '/display/auth/signin',

      authPollMs: 250,
      authMode:   'popup',
    },
    _state = {
      authenticated:    false,
      authInitResponse: null,
      authResponse:     null,
      identifyResponse: null,
      ready:            false,
    },
    _callbacks = {},
    _event = null,
    _appConfig = null,
    _ngxContext = null,
    _authWindow = null;

  // Init.
  var init = function(config) {
      // Merge injected params with our own.
      _.extend(_config, config);

      // Convenience shortcuts.
      _event = NGX.App.Events;
      _appConfig = NGX.App.config;
      _ngxContext = NGX.context;

      // Update ready state.
      _state.ready = true;
    },
    // Log user in.
    login = function(callbackSuccess, callbackFail, redirectUrl, authRedirectData) {
      // Store reference to callbacks.
      _callbacks.login = {};
      _callbacks.login.success = callbackSuccess;
      _callbacks.login.fail = callbackFail;

      // If we are processing a redirect response.
      if (authRedirectData) {
        handleStatusChange(authRedirectData.responseObject);
      } else {
        // Build the auth URL.
        var authURL =
          _appConfig.displayURL +
          _config.ngxAuthProxyURI +
          '/' +
          _ngxContext.apikey +
          '/?network=twitter&redirectUrl=' +
          encodeURIComponent(redirectUrl);

        // Open auth window or redirect based on config.
        switch (_config.authMode) {
          case 'popup':
            _authWindow = window.open(authURL, '', 'width=640, height=480');
            break;

          case 'redirect':
            window.location.href = authURL;
            break;
        }

        // Poll for login response.
        pollLoginResponse();
      }
    },
    pollLoginResponse = function() {
      try {
        // Check if the response object exists.
        if (typeof _authWindow.responseObject !== 'undefined') {
          // If it does, retrieve it and pass off to handler.
          handleStatusChange(_authWindow.responseObject);

          // Attempt to close auth window.
          _authWindow.close();
        } else {
          // Otherwise contiue to poll.
          setTimeout(pollLoginResponse, _config.authPollMs);
        }
      } catch (exception) {
        // Otherwise contiue to poll.
        setTimeout(pollLoginResponse, _config.authPollMs);
      }
    },
    // When a user logged in/out, handle the change.
    handleStatusChange = function(response) {
      // Store response.
      _state.authResponse = response;

      // If error.
      if (response.hasOwnProperty('error') && response.error !== '') {
        _state.authenticated = false;

        // Execute callback.
        _callbacks.login.fail(response.error);
      } else {
        // If success.
        _state.authenticated = true;

        // Build sanitised response object to pass to success callback.
        var authResponse = {};
        authResponse.network = _config.id;
        authResponse.data = {};

        // Execute callback.
        _callbacks.login.success(authResponse);
      }
    },
    // Identify a user (retrieve as many details about them as we can) after being logged in.
    identify = function(user, callbackSuccess, callbackFail) {
      // Store reference to callbacks.
      _callbacks.identify = {};
      _callbacks.identify.success = callbackSuccess;
      _callbacks.identify.fail = callbackFail;

      // If success.
      if (_state.authResponse !== null) {
        // Build sanitised response object to pass to success callback.
        var identifyResponse = {};
        identifyResponse.network = _config.id;

        // Attempt to extract user id.
        var id = '';
        try {
          id = _state.authResponse.id;
          id = id.toString();
        } catch (exception) {}

        // Attempt to extract name.
        var firstName = '';
        var lastName = '';
        try {
          if (_state.authResponse.hasOwnProperty('name')) {
            var nameHasParts = _state.authResponse.name.indexOf(' ') >= 0 ? true : false;
            if (nameHasParts) {
              var nameParts = _state.authResponse.name.split(' ');
              lastName = nameParts.pop();
              firstName = nameParts.join(' ');
            } else {
              firstName = _state.authResponse.name;
            }
          }
        } catch (exception) {}

        // Attempt to extract email.
        var email = '';
        try {
          if (_state.authResponse.hasOwnProperty('email')) {
            email = _state.authResponse.email;
          }
        } catch (exception) {}

        // Attempt to extract associated data.
        var associatedData = {};
        associatedData.ngxId = _config.ngxId;
        try {
          // Profile URL.
          if (_state.authResponse.hasOwnProperty('screenName')) {
            associatedData.profileUrl = 'https://twitter.com/' + _state.authResponse.screenName;
          }

          // Profile Username.
          if (_state.authResponse.hasOwnProperty('screenName')) {
            associatedData.profileUsername = _state.authResponse.screenName;
          }

          // Avatar URL.
          if (_state.authResponse.hasOwnProperty('avatar')) {
            avatar = _state.authResponse.avatar;

            // Attempt to get larger version.
            avatar = avatar.replace('_normal', '_bigger');

            associatedData.avatarUrl = avatar;
          }
        } catch (exception) {}

        identifyResponse.data = {
          id:             id,
          firstName:      firstName,
          lastName:       lastName,
          email:          email,
          associatedData: associatedData,
        };

        // Execute callback.
        _callbacks.identify.success(identifyResponse);
      } else {
        // If fail.
        // Execute callback.
        _callbacks.identify.fail();
      }
    };

  // Expose public API.
  return {
    init:              init,
    login:             login,
    identify:          identify,
    accountRestricted: false,
  };
})();
